export default __webpack_public_path__ + "53b1dd98bfdac1c1e2b4d4e89326ac9b.svg";